import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type NetworksAssignMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.AssignInput;
}>;

export type NetworksAssignMutationResult = { __typename?: 'Mutation' } & {
  networksAssign?: GraphQLTypes.Maybe<
    { __typename?: 'AssignPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const NetworksAssignDocument = gql`
  mutation networksAssign($input: AssignInput!) {
    networksAssign(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
